export const environment = {
  production: true,
  baseUrl: 'https://9jayxa0dkd.execute-api.ap-southeast-1.amazonaws.com/dev',
  baseMagnoliaPath: '/DF2',
  cloudExpoUrl: 'https://jabil-df2-cloudexpo-frontend.semr2.com',
  idlePeriodInSeconds: 3600,
  displayEnvironment: 'Development',
};
